<template>
    <div class="rating p-1">

        <el-popover v-if="value && !disabled"
            placement="top"
        >
            <base-button slot="reference" :type="selectedOption.color" :class="buttonClass" v-if="selectedOption && !comment">
                <span class="btn-inner--icon">
                    {{ selectedOption.code }}
                </span>
            </base-button>

            <base-button slot="reference" :type="selectedOption.color" :class="buttonClass" v-if="selectedOption && comment">
                <span class="btn-inner--icon">
                    <i class="tim-icons icon-quote"></i>
                </span>
            </base-button>

            <h4>{{ name }}</h4>
            <small class="description">{{ description }}</small>
            <br>
            <base-button :type="selectedOption.color" class="mt-3 btn-round btn-sm" v-if="selectedOption && selectedOption.name">
                <span class="btn-inner--icon">
                    {{ selectedOption.name }}
                </span>
            </base-button>

            <!-- Don't return to the line here !-->
            <div class="mt-3 p-2 pt-3" style="border-top:gray 1px solid" v-if="comment">
                <i class="tim-icons icon-quote" style="font-size:20px"></i>
                <p class="mb-0" style="white-space:pre-wrap;font-size:14px;line-height:normal">{{ comment }}</p>
            </div>
        
        </el-popover>

        <base-button :type="selectedOption.color" :class="buttonClass" class="btn-disabled" v-if="value && disabled && selectedOption">
            <span class="btn-inner--icon">
                {{ selectedOption.code }}
            </span>
        </base-button>
    </div>
</template>

<script>
    export default {

        props: {

            name: {
                type: String,
                required: true
            },

            description: {
                type: String,
                required: true
            },

            value: {
                type: [Number, String],
                default: -1
            },

            invert: {
                type: Boolean,
                default: false
            },

            options: {
                type: Array,
                required: true
            },

            comment: {
                type: String,
                default: null
            },

            disabled: {
                type: Boolean,
                default: false
            },
        },

        computed: {

            selectedOption() {
                return this.options[this.value]
            },

            buttonClass() {
                return this.invert 
                    ? 'btn-icon-only rounded-circle outline' 
                    : 'btn-icon-only rounded-circle'
            }
        }
    }
</script>

<style scoped>

    .description {
        white-space: pre-wrap;
    }
    .rating >>> button.outline.btn-danger {
        color: #f5365c;
        background: transparent;
        border-width: 2px;
    }
    .rating >>> button.btn-warning {
        background-color: #fbc340;
        border-color: #fbc340;
    }
    .rating >>> button.btn-warning:active {
        background-color: #fab515;
        border-color: #fab515;
    }
    .rating >>> button.outline.btn-warning {
        color: #fbc340;
        background: transparent;
        border-width: 2px;
    }
    .rating >>> button.outline.btn-info {
        color: #11cdef;
        background: transparent;
        border-width: 2px;
    }
    .rating >>> button.outline.btn-success {
        color: #2dce89;
        background: transparent;
        border-width: 2px;
    }
    .rating >>> button.outline.btn-muted {
        color: #d2e3ee;
        background: transparent;
        border-width: 2px;
        border-color: #d2e3ee;
    }
    .rating >>> button.btn-muted {
        background-color:  #d2e3ee;
        border-color: #d2e3ee;
        box-shadow: 0 4px 6px rgba(92, 92, 92, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    }
    .rating >>> button.btn-disabled,
    .rating >>> button.btn-disabled:hover {
        box-shadow: none;
        transform: none;
        cursor: default;
    }

</style>
